import PropTypes from 'prop-types'
import { Box, Button, HStack, Text, useTheme, VStack } from '@chakra-ui/react'
import React, { useMemo } from 'react'
import UnderlineHeading from '../../../components/UnderlineText/UnderlineHeading'
import InfoLabel from './InfoLabel'
import { statusTypes } from '../../../components/Table/TableCells/StatusCell/StatusCell'
import InputForm from '../../../components/InputForm/InputForm'
import { useEmployeeDataContext } from '../useEmployeeData'
import { addYears } from 'date-fns'
import { genderOptions } from '../../../utils/constants'
import { REPOSITORY } from '../../../api/repository/Repository'
import { Formik } from 'formik'
import SelectorField from '../../../components/Selector/SelectorField'
import { DatePickerField } from '../../../components/DatePicker/DatePIckerField/DatePickerField'

export default function InfoGrid() {
  const { employee, handleUpdateEmployee } = useEmployeeDataContext()
  const { lGrupo, sCentroCosto, sSucursal } =
    REPOSITORY.local.company.getCompanyData()
  const { colors } = useTheme()
  return useMemo(
    () => (
      <Formik
        enableReinitialize
        initialValues={{ ...employee }}
        onSubmit={(values) => {
          handleUpdateEmployee(values)
        }}
        validateOnBlur
        validate={(values) => {
          let error = {}

          if (!values.sNombre) {
            error.sNombre = 'Requerido'
          }
          if (!values.sApellidoPaterno) {
            error.sApellidoPaterno = 'Requerido'
          }
          if (!values.sAPellidoMaterno) {
            error.sAPellidoMaterno = 'Requerido'
          }
          // if (!values.sEMail) {
          //   error.sEMail = 'Requerido'
          // }
          return error
        }}
      >
        {({ values, errors, touched, isValid, handleSubmit, handleChange }) => (
          <VStack alignItems="flex-start" w="100%" minW="600px" spacing="30px">
            <UnderlineHeading
              variant="h5"
              text={'Información del colaborador'}
            />
            <HStack
              w="100%"
              wrap="wrap"
              alignItems="start"
              gap="24px"
              spacing={0}
            >
              <VStack
                w="40%"
                alignItems="flex-start"
                spacing="30px"
                minW="270px"
                mr="16px"
              >
                <VStack alignItems="flex-start" w="100%">
                  <InputForm
                    variant="subtitle3"
                    stackProps={{ w: '100%' }}
                    name="sNombre"
                    id="sNombre"
                    title="Nombre"
                    onChange={handleChange}
                    value={values?.sNombre || ''}
                  />
                  {errors.sNombre && touched.sNombre ? (
                    <Box>
                      <Text color={colors.log.error} variant="body3">
                        {errors.sNombre}
                      </Text>
                    </Box>
                  ) : null}
                </VStack>

                <VStack alignItems="flex-start" w="100%">
                  <InputForm
                    variant="subtitle3"
                    stackProps={{ w: '100%' }}
                    name="sApellidoPaterno"
                    id="sApellidoPaterno"
                    title="Primer Apellido"
                    onChange={handleChange}
                    value={values?.sApellidoPaterno || ''}
                  />
                  {errors.sApellidoPaterno && touched.sApellidoPaterno ? (
                    <Box>
                      <Text color={colors.log.error} variant="body3">
                        {errors.sApellidoPaterno}
                      </Text>
                    </Box>
                  ) : null}
                </VStack>

                <VStack alignItems="flex-start" w="100%">
                  <InputForm
                    variant="subtitle3"
                    stackProps={{ w: '100%' }}
                    name="sAPellidoMaterno"
                    id="sAPellidoMaterno"
                    title="Segundo Apellido"
                    onChange={handleChange}
                    value={values?.sAPellidoMaterno || ''}
                  />
                  {errors.sAPellidoMaterno && touched.sAPellidoMaterno ? (
                    <Box>
                      <Text color={colors.log.error} variant="body3">
                        {errors.sAPellidoMaterno}
                      </Text>
                    </Box>
                  ) : null}
                </VStack>
                <VStack alignItems="flex-start" w="100%">
                  <Text variant="subtitle3">Fecha de nacimiento</Text>
                  <DatePickerField
                    id="dNacimiento"
                    name="dNacimiento"
                    value={values.dNacimiento}
                    handleChange={handleChange}
                    openToDate={addYears(Date.now(), -12)}
                  />
                </VStack>
                <Box w="100%">
                  <InfoLabel title="Rut" value={values?.sRUT} />
                </Box>
                <Box w="100%">
                  <SelectorField
                    name="sSexo"
                    options={genderOptions}
                    value={values?.sSexo}
                    onChange={handleChange}
                    title={'Sexo'}
                    isClearable
                    titleType="subtitle3"
                    placeholder="Seleccione un genero"
                  />
                </Box>
                <Box w="100%">
                  <InfoLabel
                    title="Correo asociado a la cuenta del colaborador"
                    value={values?.sEmailMembership}
                  />
                </Box>
              </VStack>
              <VStack
                w="40%"
                alignItems="flex-start"
                spacing="30px"
                minW="270px"
              >
                {employee && (
                  <SelectorField
                    name="idGrupo"
                    w="100%"
                    options={lGrupo}
                    value={values?.idGrupo}
                    onChange={handleChange}
                    titleType="subtitle3"
                    title={'Grupo'}
                    isClearable
                    placeholder="Seleccione un grupo"
                  />
                )}
                <SelectorField
                  name="sSucursal"
                  w="100%"
                  options={sSucursal}
                  value={values?.sSucursal}
                  onChange={handleChange}
                  title={'Sucursal'}
                  isClearable
                  titleType="subtitle3"
                  placeholder="Seleccione una sucursal"
                />
                <SelectorField
                  name="sCentroCosto"
                  w="100%"
                  options={sCentroCosto}
                  value={values?.sCentroCosto}
                  onChange={handleChange}
                  title={'Centro de costo'}
                  isClearable
                  titleType="subtitle3"
                  placeholder="Seleccione centro de costo"
                />
                <InfoLabel
                  title="Estado"
                  value={statusTypes[employee?.sEstado]}
                />
                <InfoLabel
                  title="Fecha de ingreso"
                  value={values?.dFechaIngreso}
                />
                <Box w="100%">
                  <InputForm
                    variant="subtitle3"
                    name="sTelefonoMovil"
                    id="sTelefonoMovil"
                    title="Teléfono"
                    onChange={handleChange}
                    value={values?.sTelefonoMovil || ''}
                  />
                </Box>
                {/* <VStack alignItems="flex-start" w="100%">
                  <InputForm
                    stackProps={{ w: '100%' }}
                    name="sEMail"
                    id="sEMail"
                    variant="subtitle3"
                    title="Correo para activación de bolsillo empresa"
                    onChange={handleChange}
                    value={values?.sEMail || ''}
                  />
                  {errors.sEMail && touched.sEMail ? (
                    <Box>
                      <Text color={colors.log.error} variant="body3">
                        {errors.sEMail}
                      </Text>
                    </Box>
                  ) : null}
                </VStack> */}
              </VStack>
            </HStack>
            <Button
              mb="20px"
              w="356px"
              h="66px"
              borderRadius="8px"
              variant={isValid ? 'secondary' : 'gray500'}
              _hover={employee?.sEstado === 'DV' ? { bgColor: null } : {}}
              onClick={handleSubmit}
              disabled={employee?.sEstado === 'DV'}
            >
              Actualizar información de colaborador
            </Button>
          </VStack>
        )}
      </Formik>
    ),
    [employee],
  )
}

InfoGrid.propTypes = {
  employee: PropTypes.object,
}
